module.exports = __webpack_public_path__ + "img/ic-invoice.65858f5d.svg";